<template>
  <v-dialog v-model="dialog" persistent width="70%">
    <v-card>
      <v-container v-if="!loading">
        <v-card-title>Travel Party <span v-if="getPartnerWarning()!==''" style="font-weight: 800; color:red;margin-left: 30px;">{{ getPartnerWarning() }}</span></v-card-title>
        <v-form ref="huovTravelParty">
          <!-- travelparty member categories -->
          <v-row v-if="String(huov.inpt_code).toUpperCase() === 'AIRBNB' && isAuthorized" no-gutters>
            <v-col cols="12" class="pa-4">
              <v-alert dense outlined border="left" type="warning">
                This is an Airbnb booking. 
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <v-select v-model="huov.huov_aant_volw" :items="huov_aant_volwKeuzes" item-value="volw_nr"
                item-text="volw_oms" :label="huov.huov_aant_volw_label" @change="calcTravelParty" class="travelpadd">
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select v-model="huov.huov_aant_kind" :items="huov_aant_kindKeuzes" item-value="kind_nr"
                item-text="kind_oms" :label="huov.huov_aant_kind_label" @change="calcTravelParty" class="travelpadd">
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6">
              <v-select v-model="huov.huov_aant_baby" :items="huov_aant_babyKeuzes" item-value="baby_nr"
                item-text="baby_oms" :label="huov.huov_aant_baby_label" @change="calcTravelParty" class="travelpadd">
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select v-model="huov.huov_aant_hd" :items="huov_aant_hdKeuzes" item-value="hd_nr" item-text="hd_oms"
                :label="huov.huov_aant_hd_label" @change="calcTravelParty" class="travelpadd"></v-select>
            </v-col>
          </v-row>
          <v-row v-if="String(huov.inpt_code).toUpperCase() === 'AIRBNB' && isAuthorized">
            <v-col cols="12">
              <div class="pa-4">
                <v-checkbox
                  v-model="sendtoAirbnb"
                  :label="'Send change request to Airbnb'"
                ></v-checkbox>
                <v-alert dense outlined border="left" type="warning">
                  By checking this box, a change request will be sent to Airbnb. <strong>No actual changes will be applied in ARES</strong>. This will happen automatically when the customer accepts the change request.
                </v-alert>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="String(huov.inpt_code).toUpperCase() === 'AIRBNB' && isAuthorized && huov.hoch_pending.length>0">
            <v-col cols="12">
              <div class="pa-4">
                <v-alert dense outlined border="left" type="error">
                  Pending change request
                </v-alert>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">ID</th>
                        <th class="text-left">Request Date</th>
                        <th class="text-left">Adults</th>
                        <th class="text-left">Children</th>
                        <th class="text-left">Babies</th>
                        <th class="text-left">Pets</th>
                        <th class="text-left">From Date</th>
                        <th class="text-left">To Date</th>
                        <th class="text-left">Initiated By</th>
                        
                        <th class="text-left">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(hoch, i) in huov.hoch_pending"
                        :key="i"
                      >
                        <td>{{ hoch.hoch_id }}</td>
                        <td>{{ hoch.hoch_request_dt }}</td>
                        <td>{{ hoch.hoch_aant_volw }}</td>
                        <td>{{ hoch.hoch_aant_kind }}</td>
                        <td>{{ hoch.hoch_aant_baby }}</td>
                        <td>{{ hoch.hoch_aant_hd }}</td>
                        <td>{{ hoch.hoch_van_datum }}</td>
                        <td>{{ hoch.hoch_tm_datum }}</td>
                        <td>{{ hoch.hoch_initiated_by }}</td>
                        <td>
                            <v-tooltip bottom v-if="hoch.hoch_stat === 'PENDING'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="orange">mdi-clock-outline</v-icon>
                              </template>
                              <span>Pending</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="hoch.hoch_stat === 'ACCEPTED'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="green">mdi-check-circle-outline</v-icon>
                              </template>
                              <span>Accepted</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="hoch.hoch_stat === 'DECLINED'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                              </template>
                              <span>Declined</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="hoch.hoch_stat === 'CANCELLED'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                              </template>
                              <span>Cancelled</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="hoch.hoch_stat === 'VOID'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="red">mdi-close-circle-outline</v-icon>
                              </template>
                              <span>Voided</span>
                            </v-tooltip>
                        </td>
                        
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
         <div v-if="tpwarning!==''" style="color: orange; background-color: rgba(255, 165, 0, 0.2); margin: 14px; border: 1px solid orange; border-radius: 8px; padding: 10px; display: flex; align-items: flex-start; width: 48%;">
            <v-icon color="orange" size="24" class="mr-4">mdi-alert</v-icon>
            <div>{{ tpwarning }}</div>
         </div>
          <!-- explanations -->
          <div style="min-height: 200px;">
            <v-row no-gutters class="pl-4 pt-2">Explanation</v-row>
            <div v-if="huov.invoiceUitleg===''&&huov.onsiteUitleg===''">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-4">
                    <span style="color: lightgrey">(no explanation present)</span>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-4">
                    <span v-html="huov.invoiceUitleg"></span>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pa-4">
                    <span v-html="huov.onsiteUitleg"></span>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="String(huov.inpt_code).toUpperCase() === 'AIRBNB' && huov.new_total_price !== huov.org_total_price && isAuthorized" no-gutters>
                <v-col cols="12">
                  <div class="pa-4">
                    <v-alert dense outlined border="left" type="info">
                      Total Booking costs will change from <strong>€ {{ Number(huov.org_total_price).toFixed(2).replace('.', ',') }}</strong> to <strong>€ {{ Number(huov.new_total_price).toFixed(2).replace('.', ',') }}</strong>
                    </v-alert>
                    <div v-if="huov.invoiceUitleg2===''&&huov.onsiteUitleg2===''">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="pa-4">
                            <span>Airbnb calculates all present costs on site</span>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                    <div v-else>
                      <v-row no-gutters class="pl-4 pt-2">Explanation</v-row>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="pa-4">
                            <span v-html="huov.invoiceUitleg2"></span>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="pa-4">
                            <span v-html="huov.onsiteUitleg2"></span>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="br_small"></div>
          <v-row dense no-gutters class="px-4">
            <v-col cols="12" class="pa-4 mt-1 mb-2 red">
              <span class="white--text">Make all the changes to the travel party <B><u>in 1 action</u></B> to prevent too
                many financial lines in the booking. Booking confirmations are not sent automatically yet. Please send
                new confirmations manually.</span>
            </v-col>
          </v-row>          
        </v-form>
        <!-- buttons -->
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="primary mx-2" small @click="updTravelParty" :loading="loadingairbnb">Save</v-btn>
          <v-btn color="primary" small @click="dialog = false" :loading="loadingairbnb">Close</v-btn>
        </v-card-actions>
      </v-container>
      <v-container v-else class="pa-2">loading...</v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import mxauthorization from '@/mixins/authorization';
import {bus} from "../../main";

export default {
  mixins: [mxauthorization],
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov_aant_hdKeuzes: [],
      huov_aant_volwKeuzes: [],
      huov_aant_kindKeuzes: [],
      huov_aant_babyKeuzes: [],
      huov_hogs: [],
      huov: {hoch_pending: []},
      loading: false,
      loadingairbnb: false,
      sendtoAirbnb: true,
      isAuthorized: false,
      tpwarning: '',
    }
  },
  mounted() {
    this.getAuthorization("airbnb-reservation-alteration", "isAuthorized");
  },  
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true
      this.loading = true
      this.tpwarning = ''
      this.$axios
        .post("ares/json/ares/huov/getHuovTravelParty.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovTravelParty",
          },
          getHuovTravelParty: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {

            this.huov = res.data.getHuovTravelParty
            this.max_age_baby = res.data.getHuovTravelParty.max_age_baby
            this.max_age_child = res.data.getHuovTravelParty.max_age_child
            this.huov_aant_volwKeuzes = res.data.getHuovTravelParty.huov_aant_volwKeuzes
            this.huov_aant_kindKeuzes = res.data.getHuovTravelParty.huov_aant_kindKeuzes
            this.huov_aant_babyKeuzes = res.data.getHuovTravelParty.huov_aant_babyKeuzes
            this.huov_aant_hdKeuzes = res.data.getHuovTravelParty.huov_aant_hdKeuzes            
            this.numberOfPersonOnStartup = parseInt(this.huov.huov_aant_volw) + parseInt(this.huov.huov_aant_kind) + parseInt(this.huov.huov_aant_baby);
            this.huov_hogs = res.data.getHuovTravelParty.hogs;
            this.loading = false;
          }
        })
    },
    getPartnerWarning() {
      if(String(this.huov.inpt_code).toUpperCase() === 'AIRBNB') { return 'Attention Airbnb booking' }
      return ''
    },
    notifyHuov(param) {
      bus.$emit("reloadHuov", param);
    },       
    calcTravelParty() {
      this.$axios
        .post("ares/json/ares/huov/calcTravelParty.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "calcTravelParty",
          },
          calcTravelParty: {
            huov_encrid: this.huov.huov_encrid,
            huov_aant_volw: parseInt(this.huov.huov_aant_volw),
            huov_aant_kind: parseInt(this.huov.huov_aant_kind),
            huov_aant_baby: parseInt(this.huov.huov_aant_baby),
            huov_aant_hd: parseInt(this.huov.huov_aant_hd),
            english: true
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log(res.data);
            this.huov.invoiceUitleg = res.data.calcTravelParty.invoiceUitleg;
            this.huov.onsiteUitleg = res.data.calcTravelParty.onsiteUitleg;
            this.huov.invoiceUitleg2 = res.data.calcTravelParty.invoiceUitleg2;
            this.huov.onsiteUitleg2 = res.data.calcTravelParty.onsiteUitleg2;
            this.tpwarning = res.data.calcTravelParty.tpwarning;
            this.huov.new_total_price = res.data.calcTravelParty.new_total_price;
            this.huov.org_total_price = res.data.calcTravelParty.org_total_price;
          }
        });
    },
    updTravelParty() {
      this.loadingairbnb = true;
      this.$axios
        .post("ares/json/ares/huov/updTravelParty1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updTravelParty",
          },
          updTravelParty: {
            huov_encrid: this.huov.huov_encrid,
            huov_aant_volw: parseInt(this.huov.huov_aant_volw),
            huov_aant_kind: parseInt(this.huov.huov_aant_kind),
            huov_aant_baby: parseInt(this.huov.huov_aant_baby),
            huov_aant_hd: parseInt(this.huov.huov_aant_hd),
            sendtoAirbnb: this.sendtoAirbnb,
            huov_hogs: this.huov_hogs,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updTravelParty.text,
              color: res.data.updTravelParty.color,
            });
            if (res.data.updTravelParty.color == "success" || res.data.updTravelParty.color == "warning" ) {
              this.notifyHuov("travelparty");
            }
            this.dialog = false;
            this.loadingairbnb = false;
          }
        });
    },
  },
};
</script>

<style scoped>
.br_small {
    display: block;
    margin-bottom: 1em;
}
.def {
  cursor: default;
}  
.travelpadd {
  padding-left: 16px;
  padding-right: 16px;
}
.margin-btn {
  margin-top: 10px;
  margin-left: 10px;
}  
/* .margin-btn-lft {
    margin-left: 10px;
}   */
/* .avatar-ptr {
    cursor: pointer;
  }     */
</style>

